import { CustomFormAnswerType } from '@/graphql/generated/schemas'
import { formatDateTime } from '@/utils/formatDateTime'

import { QuickReportDisplayAnswerT } from '../types/feedTypes'

const QUICK_REPORT_DATE_TIME_FORMAT = 'HH:mm | MM/dd/yyyy'

// ISO-8601 with an explicit offset (2026-09-17T21:53:00Z, 2026-09-17T14:53+03:00); legacy
// answers arrive pre-formatted by the backend and do not match.
const ISO_INSTANT_PATTERN =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/

/**
 * Renders offset-aware DATE_TIME answers (Quick Report app, ENG-33145) in the viewer's
 * timezone like the incident timestamp; only the browser knows that zone, so the backend
 * passes the instant through. Every other answer is returned as-is.
 */
export const formatQuickReportDisplayAnswer = <
  T extends Pick<QuickReportDisplayAnswerT, 'answerType' | 'displayValue'>
>(
  answer: T
): T => {
  if (
    answer.answerType !== CustomFormAnswerType.DateTime ||
    !ISO_INSTANT_PATTERN.test(answer.displayValue)
  ) {
    return answer
  }
  try {
    return {
      ...answer,
      displayValue: formatDateTime(
        answer.displayValue,
        QUICK_REPORT_DATE_TIME_FORMAT
      ),
    }
  } catch {
    // date-fns throws on an Invalid Date; a display helper must not take the drawer down
    return answer
  }
}

export const formatQuickReportDisplayAnswers = <
  T extends Pick<QuickReportDisplayAnswerT, 'answerType' | 'displayValue'>
>(
  answers: readonly T[]
): T[] => answers.map(formatQuickReportDisplayAnswer)
